import VideoSliderPortrait from "@components/Modules/VideoSliderPortrait/VideoSliderPortrait";
import { configHome } from "@pub/config";
import { Arrow, VideoGalleryPortrait } from "@sphtech/dmg-design-system";
import cx from "classnames";
import { ReactNode } from "react";

import styles from "../homelayout.module.css";
import { HomeLayoutProps } from "./utils";

type Props = {
  data: HomeLayoutProps["data"];
};

// Desc: Social Video/Embed | Video Gallery (Portrait)
export default function HomeSocialVideoPortrait({ data }: Props): ReactNode {
  if (!data.socialVideo?.items || data.socialVideo.items.length === 0) {
    return null;
  }

  if (configHome.socialVideoPortrait?.variant === "slider") {
    return (
      <VideoSliderPortrait
        title={data.socialVideo.title}
        titleZH={data.socialVideo.titleZH}
        cta={{
          url: data.socialVideo.url,
          headingIcon: configHome.viewMore?.icon,
        }}
        items={data.socialVideo.items.map((item) => ({
          caption: "",
          videoUrl: item.embedUrl,
        }))}
      />
    );
  }

  return (
    <div className={cx(styles.socialVideoContainer)}>
      <div className={cx(styles.bodyContainer)}>
        <VideoGalleryPortrait
          title={data.socialVideo.title}
          items={data.socialVideo.items.map((item) => ({
            caption: "",
            videoUrl: item.embedUrl,
          }))}
          leftIcon={<Arrow size={54} direction="left" />}
          rightIcon={<Arrow size={54} />}
          imgWidth="250px"
          imgHeight="450px"
          noOfItemsInView={3}
          description=""
          withDivider={configHome.headingDivider}
        />
      </div>
    </div>
  );
}
